function cleanStatusText(value = "") {
  const text = String(value || "").trim().toLowerCase();
  if (!text) return "";
  if (
    text === "[object object]" ||
    text === "object" ||
    text === "null" ||
    text === "undefined"
  ) {
    return "";
  }
  return text.replace(/[\s-]+/g, "_");
}

export function normalizeVerificationStatus(value, fallback = "") {
  const text = cleanStatusText(value);
  if (!text) return fallback;

  if (["verified", "approved", "complete", "completed"].includes(text)) {
    return "verified";
  }

  if (
    [
      "pending",
      "pending_review",
      "pending_verification",
      "in_review",
      "under_review",
      "requested",
      "submitted",
    ].includes(text)
  ) {
    return "pending";
  }

  if (["rejected", "declined", "failed"].includes(text)) {
    return "rejected";
  }

  if (["unverified", "not_verified", "unknown"].includes(text)) {
    return "unverified";
  }

  return fallback || text;
}
